// extracted by mini-css-extract-plugin
export default {"Wrapper":"SubcontractsView_Wrapper__awmG4"};